export const authNavigationHanlder = () => {
  const navContainer = document.querySelector(".auth-nav");
  const formsContainer = document.querySelector(".auth");

  if (!navContainer || !formsContainer) {
    return;
  }

  const navItems = document.querySelectorAll(".auth-nav__item");
  const forms = document.querySelectorAll(".auth-form");

  navItems.forEach((item) => {
    item.addEventListener("click", () => {
      const view = item.dataset.view;

      navItems.forEach((nav) => nav.classList.remove("isActive"));
      forms.forEach((form) => form.classList.remove("isActive"));

      item.classList.add("isActive");
      document.querySelector(`.auth-form--${view}`).classList.add("isActive");

      const url = new URL(window.location);
      url.searchParams.set("view", view);
      window.history.replaceState({}, "", url);
    });
  });

  const currentView =
    new URLSearchParams(window.location.search).get("view") || "login";
  document
    .querySelector(`.auth-nav__item[data-view="${currentView}"]`)
    ?.classList.add("isActive");
  document
    .querySelector(`.auth-form--${currentView}`)
    ?.classList.add("isActive");
};
